const messages = {
  title: "Markkinointisuostumukset",
  required: "Pakollinen",
  answered: "✓ Vastattu",
  read: "Luettu",
  notRead: "Ei luettu",
  alreadyAnswered: "Jo vastattu",
  requiredQuestionsMustBeAccepted:
    "{count} pakollista kysymystä on hyväksyttävä",
  pleaseAnswerQuestions: "Vastaa seuraaviin kysymyksiin:",
  iAccept: "Hyväksyn",
  scrollToUnlock: "Vieritä alas avataksesi",
  fieldRequired: "Tämä kenttä on pakollinen",
  scrollToContinue: "↓ Vieritä alas jatkaaksesi",
  saving: "Tallennetaan...",
  saveConsents: "Tallenna suostumukset",
  allRequiredAccepted: "✓ Kaikki pakolliset kysymykset hyväksytty",
  requiredConsentsCompleted:
    "{completed}/{total} pakollista suostumusta täytetty",
  selectConsentToView:
    "Valitse suostumus luettelosta nähdäksesi sen sisällön",
  readAllContentFirst: "Lue koko sisältö ensin: {names}",
  acceptAllRequiredIn: "Hyväksy kaikki pakolliset kysymykset kohteessa: {names}",
  acceptAllBeforeSaving:
    "Hyväksy kaikki pakolliset kysymykset ennen tallennusta.",
  failedToSave: "Suostumusten tallennus epäonnistui. Yritä uudelleen.",
  errorSaving:
    "Suostumusten tallennuksessa tapahtui virhe. Yritä uudelleen.",
  failedToLoad: "Suostumusten lataus epäonnistui. Päivitä sivu.",
  viewPdf: "Näytä PDF",
  requiredConsentTitle: "Pakollinen suostumus",
  acceptAndContinue: "Hyväksy ja jatka",
};

export default {
  messages,
};
